import { render, staticRenderFns } from "./Bucket.vue?vue&type=template&id=5e912f74&scoped=true&lang=html&"
import script from "./Bucket.vue?vue&type=script&lang=js&"
export * from "./Bucket.vue?vue&type=script&lang=js&"
import style0 from "./Bucket.vue?vue&type=style&index=0&id=5e912f74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e912f74",
  null
  
)

export default component.exports